import {
  IExperienceMessageDenormalized,
  ITaskDenormalized,
  MessageStatus,
  TaskStatus
} from '@dadohr/shared/domainTypes/experience';
import { partition } from 'lodash';
import { useState } from 'react';
import { useUnsafeTranslation } from '../../../../../../i18next';
import { FlexContainerVertical } from '../../../../../../layout/Flex';
import { useGroupedTaskAndMessages } from '../../services/items';
import { CollapsibleSubHeader } from '../CollapsibleSubHeader';
import { TasksAndMessages } from '../TasksAndMessages';

export const IncompleteSection = ({
  tasks,
  messages,
  actorAccessToken,
  instanceAccessToken,
  returnTo
}: {
  tasks: ITaskDenormalized[];
  messages: IExperienceMessageDenormalized[];
  actorAccessToken: string;
  instanceAccessToken: string;

  returnTo?: string;
}) => {
  const [expanded, setExpanded] = useState(false);
  const { t } = useUnsafeTranslation();
  const tasksAndMessages = useGroupedTaskAndMessages(tasks, messages);
  const [current, upcoming] = partition(tasksAndMessages, (x) =>
    x.type === 'MSG'
      ? x.item.status !== MessageStatus.UPCOMING
      : x.item.status !== TaskStatus.NOT_STARTED
  );
  if (!current.length || !upcoming.length) {
    // can just show everything
    return (
      <TasksAndMessages
        actorAccessToken={actorAccessToken}
        instanceAccessToken={instanceAccessToken}
        returnTo={returnTo}
        ds={tasksAndMessages}
      />
    );
  }
  return (
    <>
      <TasksAndMessages
        actorAccessToken={actorAccessToken}
        instanceAccessToken={instanceAccessToken}
        returnTo={returnTo}
        ds={current}
      />
      <FlexContainerVertical fullWidth spacing={2}>
        <CollapsibleSubHeader
          title={t('For later')}
          expanded={expanded}
          toggle={() => setExpanded((x) => !x)}
        />
        {expanded && (
          <TasksAndMessages
            actorAccessToken={actorAccessToken}
            instanceAccessToken={instanceAccessToken}
            returnTo={returnTo}
            ds={upcoming}
          />
        )}
      </FlexContainerVertical>
    </>
  );
};
